export default "__VITE_ASSET__DR9ANy0e__"